import {canHearAudio, canSeeImage, canSeeVideo} from "../../../../misc/modelInsightUtils.ts";

export const addFormattedUserMessage = async (formattedMessages: any[], currentNode: any, model: string, audioFilesSeen: number, isGatherContext: boolean) => {
    const message = currentNode.message;

    let formattedMessage: any = {
        role: "user",
        content: []
    };

    let hasCache = false;
    let hasText = false;
    const imageUrls = [];
    for (const contentItem of message.content) {
        if (contentItem.cache_control) {
            hasCache = true;
        }
        if (contentItem.type === 'file') {
            formattedMessage.content.push({
                type: 'text',
                text: contentItem.fileContent.trim() === "" ? "_" : contentItem.fileContent
            });
            hasText = true;
        }
        else if (['image', 'audio', 'video'].includes(contentItem.type)) {
            if (contentItem.fileContent.startsWith('http')) {
                if (!contentItem.storeAfterUse && contentItem.type === 'image' && canSeeImage(model)) {
                    imageUrls.push(contentItem.fileContent);
                }
            }

            if (contentItem.type === 'image' && canSeeImage(model)) {
                formattedMessage.content.push({
                    type: 'image_url',
                    image_url: {
                        url: contentItem.fileContent
                    }
                });
            } else if (contentItem.type === 'audio') {
                if (canHearAudio(model) && audioFilesSeen === 0) {
                    audioFilesSeen++;

                    // Still need to support this. audioFilesSeen Won't return true yet for GPT, so this will currently never get hit
                    if (model.includes('GPT')) {
                        formattedMessage.content.push({
                            type: 'input_audio',
                            input_audio: { data: contentItem.fileContent, format: "wav" }
                        });
                    } else if (model.includes('Gemini')) {
                        formattedMessage.content.push({
                            type: "media",
                            mimeType: "audio/mp3",
                            fileUri: contentItem.fileContent
                        });
                    }
                } else {
                    if (contentItem.transcript && contentItem.transcript.trim() !== "") {
                        formattedMessage.content.push({
                            type: "text",
                            text: contentItem.transcript
                        });
                    }
                }
            } else if (contentItem.type === 'video' && canSeeVideo(model)) {
                if (model.includes('Gemini')) {
                    formattedMessage.content.push({
                        type: "media",
                        mimeType: "video/mp4",
                        fileUri: contentItem.fileContent,
                    });
                }
            }
        }
        else if (contentItem.type === "link") {
            formattedMessage.content.push({
                type: 'text',
                text: `Contents for ${contentItem.fileName}:\n"""\n${contentItem.fileContent}\n"""`
            });
            hasText = true;
        }
        else if (contentItem.type === 'text') {
            formattedMessage.content.push({
                type: 'text',
                text: contentItem.text.trim() === "" ? "_" : contentItem.text
            });
            hasText = true;
        }
    }

    if (imageUrls.length > 0) {
        formattedMessage.content.push({
            type: 'text',
            text: `Here are the URLs to all of the images I attached:\n${imageUrls.map((url: string, index: number) => `${index + 1}) ${url}`).join('\n')}`
        });
        hasText = true;
    }

    if (!isGatherContext) {
        if (message.promptPrefix) {
            const prefixElement = { type: "text", text: message.promptPrefix };

            const lastNonTextIndex = formattedMessage.content.reduce((lastIndex: number, element: any, index: number) => {
                return (typeof element === 'object' && element.type !== 'text') ? index : lastIndex;
            }, -1);

            if (lastNonTextIndex === -1) {
                formattedMessage.content.unshift(prefixElement);
            } else {
                formattedMessage.content.splice(lastNonTextIndex + 1, 0, prefixElement);
            }
        }

        if (message.promptPostfix) {
            const postfixElement = {type: "text", text: message.promptPostfix};

            formattedMessage.content.push(postfixElement);
        }
    }

    if (!hasText) {
        formattedMessage.content.push({
            type: 'text',
            text: "_"
        });
    }

    if (hasCache) {
        const contentLength = formattedMessage.content.length - 1;
        formattedMessage.content[contentLength] = {
            ...formattedMessage.content[contentLength],
            cache_control: { type: "ephemeral" }
        };
    }

    formattedMessages.push(formattedMessage);

    return audioFilesSeen;
}